import { render, staticRenderFns } from "./FlexibleStrategy.vue?vue&type=template&id=de6cba5a&scoped=true&"
import script from "./FlexibleStrategy.vue?vue&type=script&lang=js&"
export * from "./FlexibleStrategy.vue?vue&type=script&lang=js&"
import style0 from "./FlexibleStrategy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FlexibleStrategy.vue?vue&type=style&index=1&id=de6cba5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6cba5a",
  null
  
)

export default component.exports